
<mat-dialog-content style="overflow-x: hidden; "><section class="section">
  <div class="close" (click)="closeDialog()"><mat-icon>close</mat-icon></div>
  <div class="crt">Edit Driver</div>
    <div class="driverform">
    <form class="Cdrive" [formGroup]="editDriver">
      <div class="row">
        <div class="col">
          <label class="label">Driver Name:</label>
          <input type="text" class="form-control" placeholder="Name" formControlName="name">
        </div>
        <div class="col">
          <label class="label">Phone No:</label>
          <input type="text" class="form-control" placeholder="Phone No." formControlName="phoneNo">
        </div>
      </div>
      <div class="row">
          <div class="col">
            <label class="label">Email:</label>
            <input type="text" class="form-control" placeholder="Email" formControlName="email">
          </div>
          <div class="col">
            <label class="label">Vehicle Type:</label>
            <input type="text" class="form-control" placeholder="Vehicle Type" formControlName="vehicleType">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="label">Vehicle No:</label>
            <input type="text" class="form-control" placeholder="Vehicle No" formControlName="vehicleNo" >
          </div>
          <div class="col">
            <label class="label">Licence No:</label>
            <input type="text" class="form-control" placeholder="Licence No." formControlName="licenceNo">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="label">licence Validity:</label>
            <input type="text" class="form-control" placeholder="Licence Validity" formControlName="licenceValidity">
          </div>
          <div class="col">
            <label class="label">RC Validity:</label>
            <input type="text" class="form-control" placeholder="RC Validity" formControlName="rcValidity">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="label">Vehicle Name:</label>
            <input type="text" class="form-control" placeholder="Vehicle name" formControlName="vehicleName">
          </div>
        </div>
        <!-- IMAGE -->
        <div class="container">
          <div class="col" >
            <span class="span">Upload Driver Image</span>
             <input #imageInput type="file" accept="image/*" class="input"
                (change)="processFile(imageInput)" >
              <img width="100%" *ngIf="driverimage" [src]="driverimage" class="image">
             
          </div>
          
          <!-- rc upload -->
          <div class="col" >
            <span class="span">Upload Driver RC</span>
            <input #rc type="file" accept="image/*" (change)="processFile1(rc)" class="input" >
            <img width="100%" *ngIf="driverrc" [src]="driverrc" class="image">
           
          </div>
  <!-- ADDRESS -->
  <div class="col">
        <span class="span">Upload Driver Address Proof</span>
        <input #address type="file" (change)="uploadaddress(address)" accept="image/*" class="input">
<img width="100%" *ngIf="driveraddressproof" [src]="driveraddressproof" class="image" class="input" style=" height: 70px;
width: 100px;
margin-left: 10px;">
    </div>
        </div>
<!-- Licence -->
        <div class="secondrow">
          <div class="col1" >
            <span class="span">Upload Driver Licence</span>
            <input #licence type="file" accept="image/*" (change)="licencefile(licence)" class="input">
            <img width="100%" *ngIf="driverlicence" [src]="driverlicence" class="image">
          </div>
          <!-- idproof -->
          <div class="col1" >
            <span class="span">Upload Driver ID Proof</span>
            <input #idproof type="file" (change)="uploadidproof(idproof)" accept="image/*" class="input" >
            <img width="100%" *ngIf="driverid" [src]="driverid" class="image">
          </div>
        </div>


        <div class="submit">
          <button type="submit" class="btn btn-primary" (click)="editdriverdetail(editDriver.valid)">Submit</button></div>
    </form>
  </div>
  </section>
  </mat-dialog-content>
